import { ApiProperty } from "@nestjs/swagger";

export class ShiftAttendanceRequest {
    @ApiProperty()
    fromDate: string;
    @ApiProperty()
    toDate: string;
    @ApiProperty()
    shift?: string;
    @ApiProperty()
    employeeId?: string;

    /**
     * 
     * @param fromDate 
     * @param toDate 
     * @param shift 
     * @param employeeId 
     */
    constructor(fromDate: string, toDate: string, shift?: string,employeeId?: string) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.shift = shift;
        this.employeeId = employeeId
    }
}